import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-bottom: 24px;

  #dropdown-area {
    min-width: 260px;
  }
`;
